import script from "./SkeletonHomepageMyVideos.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonHomepageMyVideos.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonHomepageMyVideos.vue?vue&type=style&index=0&id=61178199&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61178199"]])

export default __exports__